export default "__VITE_ASSET__CAr$FgQg__"